import type { RefetchFn } from "@msuite/ui/query";
import type { Enums } from "@msuite/utils/types";
import { IntegrationPersonioForm } from "./integration-personio-form";
import { IntegrationWebfleetForm } from "./integration-webfleet-form";

/** Props Interface */
interface IntegrationFormProps {
	integrationType: Enums<"integrationType">;
	refetch: RefetchFn;
}

export function IntegrationForm({ integrationType, refetch }: IntegrationFormProps) {
	if (integrationType === "personio") {
		return <IntegrationPersonioForm refetch={refetch} />;
	} else if (integrationType === "webfleet") {
		return <IntegrationWebfleetForm refetch={refetch} />;
	}
	return <div>Unsupported integration type: {integrationType}</div>;
}
